import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PrivilegeType } from '../../PrivilegeConfig/PrivilegeConfig.types';
import { Strong } from '../../../components/atoms/Strong/Strong';

type AdditionalPrivilegesRestrictionsListProps = {
  additionalPrivilegesRestrictions: PrivilegeType[];
};

export function AdditionalPrivilegesRestrictionsList({
  additionalPrivilegesRestrictions,
}: AdditionalPrivilegesRestrictionsListProps) {
  const readRestrictionTranslation = useSonTranslation('PageReadRestrictions');
  const privilegeTranslation = useSonTranslation('PrivilegeConfig');

  return (
    <ul>
      {additionalPrivilegesRestrictions.map(privilege => (
        <li key={privilege}>
          <p>
            <dfn className="page-read-restrictions__dfn">
              {readRestrictionTranslation.t('additionalPrivilegesRestrictions.visibleBy')}:{' '}
            </dfn>
            <Strong>
              {/* @ts-expect-error typing problem because of dynamic input */}
              {privilegeTranslation.t(`input.${privilege.toLowerCase()}.label`)}
            </Strong>
          </p>
        </li>
      ))}
    </ul>
  );
}
